import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, ArrowRight } from 'lucide-react';
import { CTASection } from '../components/CTASection';
import { Modal } from '../components/Modal';
import { ApplyForm } from '../components/ApplyForm';
export function Careers() {
  const [selectedJob, setSelectedJob] = useState<string | null>(null);
  const jobs = [{
    title: 'Local SEO Specialist',
    location: 'Remote',
    type: 'Full-time',
    department: 'Marketing'
  }, {
    title: 'Account Manager',
    location: 'Remote',
    type: 'Full-time',
    department: 'Client Success'
  }, {
    title: 'Frontend Developer',
    location: 'Remote',
    type: 'Contract',
    department: 'Engineering'
  }];
  return <main className="pt-24" data-id="element-399">
      <section className="bg-navy py-24 relative overflow-hidden" data-id="element-400">
        <div className="absolute inset-0 z-0 opacity-20" data-id="element-401">
          <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1600&q=80" alt="Remote work setup" className="w-full h-full object-cover" data-id="element-402" />
        </div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-403">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white mb-6" data-id="element-404">
            Join Our Remote Team
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-405">
            Help local businesses grow while working from anywhere in the world.
          </motion.p>
        </div>
      </section>

      <section className="py-20 bg-surface" data-id="element-406">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-407">
          <div className="mb-12 text-center" data-id="element-408">
            <h2 className="text-3xl font-heading font-bold text-navy mb-4" data-id="element-409">
              Open Positions
            </h2>
            <p className="text-muted" data-id="element-410">
              We're always looking for talented individuals to join our growing
              team.
            </p>
          </div>

          <div className="space-y-4" data-id="element-411">
            {jobs.map((job, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow flex flex-col sm:flex-row sm:items-center justify-between gap-4 group" data-id="element-412">
                <div data-id="element-413">
                  <h3 className="text-xl font-bold text-navy mb-2" data-id="element-414">
                    {job.title}
                  </h3>
                  <div className="flex flex-wrap items-center gap-4 text-sm text-muted" data-id="element-415">
                    <span className="flex items-center gap-1" data-id="element-416">
                      <MapPin size={16} data-id="element-417" /> {job.location}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-418">
                      <Clock size={16} data-id="element-419" /> {job.type}
                    </span>
                    <span className="bg-blue-soft text-blue px-2 py-0.5 rounded-full font-medium" data-id="element-420">
                      {job.department}
                    </span>
                  </div>
                </div>
                <button onClick={() => setSelectedJob(job.title)} className="flex items-center justify-center gap-2 px-6 py-2.5 bg-transparent border-2 border-navy text-navy font-semibold rounded-md hover:bg-navy hover:text-white transition-colors whitespace-nowrap" data-id="element-421">
                  Apply Now <ArrowRight size={16} data-id="element-422" />
                </button>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-423" />

      <Modal isOpen={selectedJob !== null} onClose={() => setSelectedJob(null)} title="Apply for this role" subtitle="We're excited to hear from you. Fill out the form below." data-id="element-424">
        {selectedJob && <ApplyForm jobTitle={selectedJob} onClose={() => setSelectedJob(null)} data-id="element-425" />}
      </Modal>
    </main>;
}